import React from "react";
import { Table } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function AddCoRoleLoader({ row }) {
  const renderSkeletonRow = (index) => (
    <tr key={index}>
      {Array.from({ length: 3 }).map((_, index) => (
        <td key={index}>
          <Skeleton />
        </td>
      ))}
    </tr>
  );

  return (
    <>
      <Table className="mb-10" bordered responsive>
        <tbody>
          {Array.from({ length: row }).map((_, index) =>
            renderSkeletonRow(index),
          )}
        </tbody>
      </Table>
    </>
  );
}

export default AddCoRoleLoader;
